import { FacetAction } from "./facet-action";

class FacetOption extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener("change", this.onInputChange.bind(this))
    }

    onInputChange(event: Event) {
        const url = this.generateURLHash();
        const facetAction = new FacetAction();
        facetAction.updateURLHash(url);
        facetAction.fetchPageContent(url);
    }

    generateURLHash() {
        const inputElement = this.querySelector("input");
        const isChecked = inputElement?.checked;
        let url: string = '';

        if(isChecked) {
            url = inputElement?.getAttribute("data-add-url") as string;
        }
        else {
            url = inputElement?.getAttribute("data-remove-url") as string;
        }
        return url;
    }
}

customElements.define("facet-option", FacetOption);
